export default function Titel({ title, ...props }) {
  return (
    <div {...props}>
      <h3 className="font-bold text-[20px] text-right mb-1">{title}</h3>

      <div
        className="h-[3px] w-full"
        style={{
          background: "linear-gradient(90deg , #E3013F 0% , #E3E2DF 100% )",
        }}
      ></div>
    </div>
  );
}
